import React from 'react';

import {ErrorBoundary} from '~ui/components/ErrorBoundary';

export const withErrorBoundary = <P extends {}>(Component: React.FC<P>) =>
    function WithErrorBoundary(props: P) {
        return (
            <ErrorBoundary>
                <Component {...props} />
            </ErrorBoundary>
        );
    };
